import { useState } from "react";
import { useData } from "../context/DataContext";
import { useGo } from "../hooks/useSiteNav";
import { C, G } from "../styles/theme";
import { IMG, PIMG } from "../data/initialData";
import FImg from "../components/common/FImg";
import Dlg from "../components/common/Dlg";
import PBtn from "../components/common/PBtn";
import HeroBanner from "../components/layout/HeroBanner";
import StickyLabCTA from "../components/widgets/StickyLabCTA";
import LiveCount from "../components/widgets/LiveCount";
import CompareBar from "../components/widgets/CompareBar";
import CompareModal from "../components/widgets/CompareModal";
import Testimonials from "../components/widgets/Testimonials";

export default function Lab() {
  const { db } = useData();
  const go = useGo();
  const s = db.settings || {};
  const testi = db.testimonials || [];

  const [cat, setCat] = useState("All");
  const [srch, setSrch] = useState("");
  const [sel, setSel] = useState(null);
  const [cmpList, setCmpList] = useState([]);
  const [cmpOpen, setCmpOpen] = useState(false);

  const addCmp = p => { if (cmpList.find(x => x.id === p.id) || cmpList.length >= 3) return; setCmpList(l => [...l, p]); };
  const remCmp = id => setCmpList(l => l.filter(x => x.id !== id));

  const active = (db.products || []).filter(p => p.status === "active");
  const cats = ["All", ...[...new Set(active.map(p => p.category))]];
  const vis = active.filter(p => (cat === "All" || p.category === cat) && (!srch || p.name.toLowerCase().includes(srch.toLowerCase())));

  return (
    <div style={{ background: C.bg }}>
      <StickyLabCTA go={go} />
      {s.labBannerEnabled && s.labBannerText && (
        <div style={{ background: "linear-gradient(90deg,#0F6E56,#22c55e)", padding: "9px 24px", textAlign: "center", fontSize: 13, fontWeight: 600, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
          <span>{s.labBannerText}</span>
          <button onClick={() => go("contact")} style={{ background: "rgba(255,255,255,.2)", border: "1px solid rgba(255,255,255,.3)", color: "#fff", fontWeight: 700, fontSize: 11, padding: "3px 12px", borderRadius: 20, cursor: "pointer", flexShrink: 0 }}>Enquire Now</button>
        </div>
      )}
      <HeroBanner tag={s.labHeroTag || "Cyclojet Lab"} title={s.labHeroTitle || "GC Lab Instruments & Consumables"} sub={s.labHeroSub || "Complete range of GC instruments for your laboratory."} b1="Request a Quote" b2="Contact Us" ob1={() => go("contact")} ob2={() => go("contact")} img={(s.pageImages?.lab?.[0]?.url) || IMG.lab} />
      <div style={{ padding: "44px 24px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div style={{ marginBottom: 6 }}><LiveCount /></div>
          <div style={{ display: "flex", gap: 9, flexWrap: "wrap", marginBottom: 20, alignItems: "center", background: "#fff", padding: "14px 18px", borderRadius: 11, border: `1px solid ${C.border}`, boxShadow: "0 2px 8px rgba(26,60,110,.05)" }}>
            <input value={srch} onChange={e => setSrch(e.target.value)} placeholder="Search products..." style={{ padding: "8px 12px", border: `1.5px solid ${C.border}`, borderRadius: 7, fontSize: 13.5, width: 210, outline: "none", background: C.bg }} />
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", flex: 1 }}>
              {cats.map(c => <button key={c} onClick={() => { setCat(c); setSrch(""); }} style={{ background: cat === c ? C.blue : "transparent", color: cat === c ? "#fff" : C.gray, border: "1.5px solid " + (cat === c ? C.blue : C.border), padding: "6px 13px", borderRadius: 7, fontSize: 12.5, fontWeight: cat === c ? 700 : 500, cursor: "pointer", transition: "all .15s" }}>{c}</button>)}
            </div>
            <span style={{ fontSize: 12.5, color: C.gray, flexShrink: 0 }}>{vis.length} products</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))", gap: 16, paddingBottom: cmpList.length ? 70 : 0 }}>
            {vis.map(p => {
              const inCmp = !!cmpList.find(x => x.id === p.id);
              return (
                <div key={p.id} className="hl" onClick={() => setSel(p)} style={{ background: "#fff", borderRadius: 13, overflow: "hidden", cursor: "pointer", boxShadow: "0 2px 12px rgba(26,60,110,.06)", border: `1px solid ${C.border}` }}>
                  <FImg src={PIMG[p.category] || PIMG.default} h={140} placeholder={p.category} style={{ width: "100%", height: 140, objectFit: "cover" }} />
                  <div style={{ padding: "12px 14px 14px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6, alignItems: "center" }}>
                      <span style={{ background: "#dbeafe", color: "#1e40af", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{p.category}</span>
                      <span style={{ fontSize: 11, fontWeight: 700, color: p.stock <= 10 ? C.red : p.stock <= 20 ? C.amber : C.teal }}>{p.stock <= 10 ? "Low stock" : p.stock <= 20 ? "Limited" : "In stock"}</span>
                    </div>
                    <h4 style={{ fontSize: 13.5, fontWeight: 700, color: C.blue, marginBottom: 4 }}>{p.name}</h4>
                    <p style={{ fontSize: 12, color: C.gray, lineHeight: 1.5, marginBottom: 8, minHeight: 32 }}>{p.desc}</p>
                    <div style={{ fontSize: 11, color: C.teal, fontWeight: 600, marginBottom: 9 }}>Compatible: {p.compat}</div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 9, borderTop: `1px solid ${C.border}` }}>
                      <span style={{ fontSize: 15, fontWeight: 800, color: C.blue }}>Rs.{p.price.toLocaleString()}<span style={{ fontSize: 10, color: C.gray, fontWeight: 400 }}> /{p.unit}</span></span>
                      <div style={{ display: "flex", gap: 5 }}>
                        <button style={{ background: inCmp ? "#dbeafe" : "transparent", color: inCmp ? "#1e40af" : C.gray, border: "1px solid " + (inCmp ? "#93c5fd" : C.border), padding: "5px 9px", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: "pointer" }} onClick={e => { e.stopPropagation(); inCmp ? remCmp(p.id) : addCmp(p); }}>
                          {inCmp ? "Added" : "+ Compare"}
                        </button>
                        <button style={{ background: G.orange, color: "#fff", border: "none", padding: "5px 12px", borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: "pointer" }} onClick={e => { e.stopPropagation(); go("contact"); }}>Quote</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {sel && <Dlg title={sel.name} onClose={() => setSel(null)}>
        <FImg src={PIMG[sel.category]} h={170} style={{ width: "100%", height: 170, objectFit: "cover", borderRadius: 10, marginBottom: 14 }} />
        <p style={{ fontSize: 13.5, color: C.gray, marginBottom: 14, lineHeight: 1.7 }}>{sel.desc}</p>
        <div style={{ background: C.bg, borderRadius: 9, padding: 12, marginBottom: 14 }}>
          {[["Category", sel.category], ["Price", "Rs." + sel.price.toLocaleString() + " / " + sel.unit], ["Stock", sel.stock + " units"], ["Compatible", sel.compat]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: `1px solid ${C.border}`, fontSize: 13 }}><span style={{ fontWeight: 600, color: C.blue }}>{k}</span><span style={{ color: C.gray, maxWidth: "60%", textAlign: "right" }}>{v}</span></div>
          ))}
        </div>
        <PBtn onClick={() => { setSel(null); go("contact"); }} full>Request a Quote</PBtn>
      </Dlg>}
      <Testimonials items={testi} />
      <CompareBar items={cmpList} onRemove={remCmp} onClear={() => setCmpList([])} onCompare={() => setCmpOpen(true)} />
      {cmpOpen && <CompareModal items={cmpList} onClose={() => setCmpOpen(false)} />}
    </div>
  );
}
